import React from "react";
import { connect } from "react-redux";
import { Button, Form, Container, Row, Col } from "react-bootstrap";
import { Field, reduxForm } from "redux-form";
import { required, noSpaces } from "utils/validation";
import { reduxFormInput } from "components/form/ReduxForm";
import { createTag, updateTag } from "redux/actions";
import Spacer from "components/layout/Spacer";

class CreateEditTag extends React.Component {
  constructor(props) {
    super(props);

    this.submitFn = this.submitFn.bind(this);
  }

  submitFn(data) {
    const { promptType, tagSelected } = this.props;

    if (promptType === "create") {
      createTag({ tag: data.tag });
    } else {
      updateTag(tagSelected._id, { tag: data.tag });
    }
  }

  render() {
    const { action, handleSubmit } = this.props;
    const isProcessing =
      action.CREATE_TAG.isFetching || action.UPDATE_TAG.isFetching;

    return (
      <>
        <Container>
          <Form
            className="no-border no-padding"
            onSubmit={handleSubmit(this.submitFn)}
          >
            <Row>
              <Col xs="12">
                <Field
                  className="form-control"
                  component={reduxFormInput}
                  validate={[required, noSpaces]}
                  name="tag"
                  type="text"
                  placeholder="Enter tag"
                  label="*Tag"
                />
              </Col>
            </Row>
            <Spacer size={50} />
            <Row className="justify-content-center">
              <Col className="text-center" xs="12" sm="6">
                <Button disabled={isProcessing} type="submit" variant="primary">
                  {isProcessing ? "Saving..." : "Save"}
                </Button>
              </Col>
            </Row>
          </Form>
          <Spacer size={50} />
        </Container>
      </>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    action: state.action,
    initialValues: {
      tag: props.tagSelected?.tag || "",
    },
  };
}

export default connect(mapStateToProps)(
  reduxForm({
    form: "register",
    enableReinitialize: true,
  })(CreateEditTag)
);
